import red from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  root: {
    textTransform: 'none',
  },
  typography: {
    fontFamily: 'Geomanist',
    useNextVariants: true,
    button: {
      textTransform: 'none',
    },
    subtitle1: {
      fontSize: '13px !important',
      fontFamily: 'Basier Circle',
      fontWeight: 400,
      lineHeight: '18px !important',
      letterSpacing: -0.2,
    },
  },
  palette: {
    fatsoma: {
      yellow: '#FFBF1B',
      black: '#000',
    },
    primary: {
      light: '#222',
      main: '#000',
      dark: '#000',
      contrastText: '#ffffff',
      textColor: '#333',
    },
    secondary: {
      light: '#4e5263',
      main: '#000',
      dark: '#1b1f30',
      contrastText: '#ffffff',
      textColor: '#333',
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  overrides: {
    MuiButton: {
      root: {
        height: '44px',
      },
      raised: {
        boxShadow: '0 0px 0px 0px rgba(0,0,0,0)',
      },
    },
  },
});

theme.spacing.unit = 8;

export default theme;



// WEBPACK FOOTER //
// ./src/styles/light.jsx